
import { motion } from "framer-motion";

interface TimelineCollapsedViewProps {
  isEven: boolean;
}

// This component is now essentially a placeholder as the header is rendered by the parent
const TimelineCollapsedView = ({ isEven }: TimelineCollapsedViewProps) => {
  return null; // We don't need to render anything in collapsed state as header is persistent
};

export default TimelineCollapsedView;
